import styled from "styled-components";
import { colors } from "../../../styles/variables";

export const StyledWrapper = styled.div`
  margin: 80px auto;
  max-width: 560px;
  text-align: center;
`;

export const StyledTitle = styled.div`
  color: ${colors.gray900};
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 5px;
`;

export const StyledSubtext = styled.div`
  color: ${colors.gray600};
  text-align: center;
  font-size: 16px;
  font-weight: 400;
`;
